<template>
  <div>
    <main>
      <b-container fluid class="p-0">
        <router-view></router-view>
      </b-container>
    </main>
  </div>
</template>
<script>
export default {

};
</script>
<style>
html,
body,
main {
  height: 100% !important;
}
</style>
